export default (function replaceLineEndings(text, replacement) {
  return text.replace(/(?:\r\n|\r|\n)/g, replacement);
});